import ApiClient from './ApiClient';

export interface LaborCostCustomItemMst {
  customId: string | null;
  companyCode: string;
  customItemName: string;
  dispOrder: number;
  includeAttend: boolean;
  includeSales: boolean;
}

export const getList = async (companyCode: string): Promise<Array<LaborCostCustomItemMst>> => {
  const response = await ApiClient.get(`/v1/attend/laborCostCustomItemMst/${companyCode}`, {});
  return response.data;
};

export const save = async (
  companyCode: string,
  loginStaffCode: string,
  item: LaborCostCustomItemMst,
): Promise<LaborCostCustomItemMst> => {
  const response = await ApiClient.postJsonData(
    `/v1/attend/laborCostCustomItemMst/${companyCode}`,
    { loginStaffCode },
    item,
  );
  return response.data;
};

export interface LaborCostCustomItemStaffValue {
  customId: string;
  amount: number;
}

export const saveStaffItems = async (
  companyCode: string,
  loginStaffCode: string,
  staffCode: string,
  orgCode: string,
  targetMonth: string,
  items: Array<LaborCostCustomItemStaffValue>,
): Promise<void> => {
  const payload = items.map((item) => ({
    staffCode,
    customId: item.customId,
    targetMonth,
    orgCode,
    amount: item.amount,
  }));
  await ApiClient.postJsonData(
    `/v1/attend/laborCostCustomItemStaff/${companyCode}`,
    { loginStaffCode },
    payload,
  );
};

export const deleteCustomItem = async (
  companyCode: string,
  customId: string,
): Promise<void> => {
  await ApiClient.delete(`/v1/attend/laborCostCustomItemMst/${companyCode}/${customId}`, {});
};
